var _desc, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAquarius(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Aquarius") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Aquarius",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12,17 C14.209,17 16,15 16,13 L14,13 C14,14 13.103,15 12,15 C10.897,15 10,14.103 10,13 L8,13 C8,15.209 9.791,17 12,17",
    id: "Wave",
    fill: "#000000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18,17 C20.209,17 22,15 22,13 L20,13 C20,14 19.103,15 18,15 C16.897,15 16,14.103 16,13 L14,13 C14,15.209 15.791,17 18,17",
    id: "Wave",
    fill: "#000000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6,17 C8.209,17 10,15 10,13 L8,13 C8,14 7.103,15 6,15 C4.897,15 4,14.103 4,13 L2,13 C2,15.209 3.791,17 6,17",
    id: "Wave",
    fill: "#000000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12,11 C14.209,11 16,9 16,7 L14,7 C14,8 13.103,9 12,9 C10.897,9 10,8.103 10,7 L8,7 C8,9.209 9.791,11 12,11",
    id: "Wave",
    fill: "#000000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18,11 C20.209,11 22,9 22,7 L20,7 C20,8 19.103,9 18,9 C16.897,9 16,8.103 16,7 L14,7 C14,9.209 15.791,11 18,11",
    id: "Wave",
    fill: "#000000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6,11 C8.209,11 10,9 10,7 L8,7 C8,8 7.103,9 6,9 C4.897,9 4,8.103 4,7 L2,7 C2,9.209 3.791,11 6,11",
    id: "Wave",
    fill: "#000000"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAquarius);
export default __webpack_public_path__ + "static/media/aquarius.28ecd7f590f62ce81ba1bd33a0f32dfc.svg";
export { ForwardRef as ReactComponent };